/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type subsidy_SubsidyOfficeCreateRequest = {
    address_line_1?: string;
    address_line_2?: string;
    auto_create_debtor?: boolean;
    calculation_method?: subsidy_SubsidyOfficeCreateRequest.calculation_method;
    city?: string;
    country?: string;
    iban?: string;
    name: string;
    notes?: string;
    postal_code?: string;
    qr_iban?: string;
};
export namespace subsidy_SubsidyOfficeCreateRequest {
    export enum calculation_method {
        ZURICH_BF = 'zurich_bf',
        FLAT = 'flat',
    }
}

